// extracted by mini-css-extract-plugin
module.exports = {"main":"GamePlay_main__2FMOp","game_board_wrapper":"GamePlay_game_board_wrapper__2dS-m","game_board":"GamePlay_game_board__33aQr","game_card":"GamePlay_game_card__IMsY3"};